<p-toast position="top-right"></p-toast>
<div class="p-g loginLogs req-management">
  <div class="p-g-12">
    <div class="card card-w-title" [ngClass]="{ 'loading': loading }">

      <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
          styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
      </div>

      <h1 class="req-Title" style="padding-top: 20px; padding-left: 10px;">{{setLabel("loginLogsLabel")}}</h1>
      <p-table #dt dataKey="id" styleClass="p-table-customers req-management-table"
      [rowHover]="true" [rows]="100" [showCurrentPageReport]="true" [loading]="loading" [paginator]="true"
      currentPageReportTemplate="There are records" [filterDelay]="0" [value]="loginLogsdata"
      [globalFilterFields]="['name','country.name','representative.name','status']" class="p-table-tecfolk-fix">




        <ng-template pTemplate="header">
          <tr>
            <th style="text-align: left; width: 85px !important;">{{setLabel("srNoLabel")}}</th>
            <th style="text-align: left;">{{setLabel("createdDateLabel")}}</th>
            <th style="text-align: left;">{{setLabel("nameLabel")}}</th>
            <th style="text-align: left;">{{setLabel("emailLabel")}}</th>
            <th style="text-align: left;">{{setLabel("contactLabel")}}</th>
            <th style="text-align: left;">{{setLabel("cityLabel")}}</th>
            <th style="text-align: left;">{{setLabel("countryLabel")}}</th>
            <th style="text-align: left;">{{setLabel("usernameLabel")}}</th>
            <th style="text-align: left;">{{setLabel("gymNameLabel")}}</th>
            <th style="text-align: left;">{{setLabel("iPAddressLabel")}}</th>
            <th style="text-align: left;">{{setLabel("iPLocationLabel")}}</th>
          </tr>

        </ng-template>
        <ng-template pTemplate="body" let-loginLogsdata>
          <tr class="p-selectable-row ">
            <td>
              <div class="req-Lable">{{setLabel("srNoLabel")}}</div>
              <span class="p-column-title">{{ loginLogsdata.counter }}</span>
            </td>
            <td style="text-align: left;">
              <div class="req-Lable">{{setLabel("createdDateLabel")}}</div>
              <!-- <span class="p-column-title">{{loginLogsdata.createdDate | date: 'M/d/yy'}}</span> -->
              <span class="p-column-title">{{ loginLogsdata.createdDate | date: 'M/d/yy h:mm a' }}</span>

            </td>
            <td style="text-align: left;">
              <div class="req-Lable">{{setLabel("nameLabel")}}</div>
              <span class="p-column-title">{{loginLogsdata.name}}</span>
            </td>
            <td style="text-align: left;" class="column-container">
              <div class="req-Lable">{{setLabel("emailLabel")}}</div>
              <span class="p-column-title"  title="{{ loginLogsdata?.email }}">{{loginLogsdata?.email}}</span>
            </td>
            <td style="text-align: left;" class="column-container">
              <div class="req-Lable">{{setLabel("contactLabel")}}</div>
              <span class="p-column-title" title="{{ loginLogsdata?.contact }}">{{loginLogsdata?.contact}}</span>
            </td>
            <td style="text-align: left;" >
              <div class="req-Lable">{{setLabel("cityLabel")}}</div>
              <span>{{loginLogsdata.city}}</span>
            </td>
            <td style="text-align: left;">
              <div class="req-Lable">{{setLabel("countryLabel")}}</div>
              <span>{{loginLogsdata.country}}</span>
            </td>
            <td style="text-align: left;" class="column-container">
              <div class="req-Lable">{{setLabel("usernameLabel")}}</div>
              <span title="{{ loginLogsdata?.username }}">{{loginLogsdata?.username}}</span>
            </td>
            <td style="text-align: left;" class="column-container">
              <div class="req-Lable">{{setLabel("gymNameLabel")}}</div>
              <span title="{{ loginLogsdata?.gymName }}">{{loginLogsdata?.gymName}}</span>
            </td>
            <td style="text-align: left;">
              <div class="req-Lable">{{setLabel("iPAddressLabel")}}</div>
              <span id="span">{{loginLogsdata?.ipAddress}}</span>
            </td>
            <td style="text-align: left;">
              <div class="req-Lable">{{setLabel("iPLocationLabel")}}</div>
              <div>
                <span>{{ loginLogsdata?.ipLocation[0]?.city }}, {{ loginLogsdata?.ipLocation[0]?.country }}</span>
              </div>
            </td>

          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td colspan="2">{{setLabel("overallTotal:Label")}}</td>
            <td>{{totalCount}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" style="text-align:left">{{setLabel("noLoginLogsFoundLabel")}}</td>
          </tr>
        </ng-template>
      </p-table>

      <div class="content" style="width: 50%; margin-left: auto;">
        <p-table [value]="tableData">
          <ng-template pTemplate="header">
          </ng-template>
      </p-table>
    </div>
    </div>
  </div>
</div>
